
























import { ServiceTaskType } from "@/servicetask/api/service-tasks-api";
import { Component, Vue } from "vue-property-decorator";
import {
  ConstructionTask,
  getConstructionTasks
} from "../../api/construction-task-api";

/**
 * 社内タスクの一覧ページ
 */
@Component({
  components: {}
})
export default class ConstructionTaskListPage extends Vue {
  fields = [
    { key: "name", label: "タスク" },
    { key: "serviceTaskType", label: "工程表名" },
    { key: "alignment", label: "順番" }
  ];

  private tasks: ConstructionTask[] = [];

  get templateOptions() {
    return this.$store.state.serviceTaskTypes.reduce(
      (m: Record<string, string>, t: ServiceTaskType) => {
        m[String(t.id)] = t.name;
        return m;
      },
      {}
    );
  }

  get items() {
    return this.tasks.map(t => ({
      id: t.id,
      name: t.name,
      serviceTaskType: this.templateOptions[String(t.serviceTaskTypeId)],
      alignment: getAlignmentLabel(t.turn)
    }));
  }

  public created() {
    this.loadTemplateList();
  }

  private async loadTemplateList() {
    this.tasks = await getConstructionTasks();
  }
}

function getAlignmentLabel(alignment: number): string {
  // TODO: 外に切り出す
  const alignmentLabel: Record<string, string> = {
    "0": "表示なし",
    "1": "左",
    "2": "中央",
    "3": "右"
  };
  return alignmentLabel[String(alignment)] || "";
}
